import React, { useEffect, useRef, useState } from "react";
import $ from "jquery";
import * as R from "ramda"; //createServiceData
import { createServiceData, updateServiceData, deleteServiceData, generateLettersForUserIdAndUserServiceId, generateLettersForUserId } from "../../../../../../../actions/facilita-api";
import ServiceData from "../../../../../../../constants/models/serviceData";
import Generic from "../../../../../../../constants/models/servicePayloads/generic";
import { ConnectionTypes, convertConnectionTypesToServiceType } from "../../../../../../../constants/utils/connectionTypes";
import { useDispatch } from "react-redux";
import * as Loadings from "../../../../../../../constants/loadings/facilita/deathDeclaration";

export const Box = ({ isCollapsed, setServiceOnFocus, branch, contractReference, setContractReference, inputOnFocus, connectionType, boxIndex, setSearchFilter, isLoading, userId, serviceDatas, displayComments, disableModifications, generateLetters }) => {
	var countries = require("i18n-iso-countries");
	countries.registerLocale(require("i18n-iso-countries/langs/fr.json"));
	const dispatch = useDispatch();
	const inputRef = useRef(null);
	const [payloads, setPayloads] = useState({ items: [{ id: "new", payload: new Generic({ reference: "", comment: "" }) }] });
	const [toDelete, setToDelete] = useState([]);
	const [autoFocus, setAutoFocus] = useState(false);

	let addressName =
		(!R.isNil(branch.address.streetAddress) ? branch.address.streetAddress : "") +
		(!R.isNil(branch.address.streetAddress2) ? " " + branch.address.streetAddress2 : "") +
		(!R.isNil(branch.address.streetAddress3) ? " " + branch.address.streetAddress3 : "") +
		(!R.isNil(branch.address.postalCode) && !R.isNil(branch.address.addressLocality) ? "," + branch.address.postalCode + " " + branch.address.addressLocality : "") +
		(!R.isNil(branch.address.addressCountry) ? ", " + countries.getName(branch.address.addressCountry, "fr", { select: "official" }) : "");

	if (branch.name == "Compléter ultérieurement") {
		addressName = "";
	}
	function loadReferences() {
		let allServicesWithSameBranch = serviceDatas.filter((b) => b.serviceId === branch.id);
		let tmpPayloads = { items: payloads.items.filter((i) => toDelete.findIndex((d) => d === i.id) === -1) };
		allServicesWithSameBranch.forEach((br) => {
			if (tmpPayloads.items.findIndex((tmp) => tmp.id === br.id) === -1) {
				tmpPayloads.items.push({ id: br.id, payload: br.payload });
			}
		});
		if (allServicesWithSameBranch.length > 0 && tmpPayloads.items.length > 0) {
			if (tmpPayloads.items[0].payload.reference === "") {
				tmpPayloads.items.splice(0, 1);
			}
			setPayloads(tmpPayloads);
		}
		setToDelete([]);
	}

	useEffect(() => {
		loadReferences();
		$('[data-toggle="tooltip"]').tooltip();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	useEffect(() => {
		loadReferences();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [serviceDatas]);

	let fieldName = "Référence";
	if (connectionType === ConnectionTypes.socialNetworks) {
		fieldName = "Nom d'utilisateur, adresse e-mail ou téléphone";
	} else if (connectionType === ConnectionTypes.homeService) {
		fieldName = "Référence ou nº CESU";
	} else if (connectionType === ConnectionTypes.multimedia) {
		fieldName = "Référence ou adresse e-mail";
	} else if (connectionType === ConnectionTypes.technology) {
		fieldName = "Référence ou adresse e-mail";
	} else if (connectionType === ConnectionTypes.music) {
		fieldName = "Référence ou adresse e-mail";
	} else if (connectionType === ConnectionTypes.poleEmploi) {
		fieldName = "Numéro d'adhérent";
	} else if (connectionType === ConnectionTypes.socialSecurity) {
		fieldName = "Numéro de Sécurité Sociale";
	} else if (connectionType === ConnectionTypes.caf) {
		fieldName = "Numéro de Sécurité Sociale";
	} else if (connectionType === ConnectionTypes.taxes) {
		fieldName = "Numéro fiscal";
	}

	if (isCollapsed) {
		return (
			<div
				className="card rounded border-common flex-xl-row picker-card"
				onClick={() => {
					setServiceOnFocus(branch.id);
				}}>
				<div className="card-header py-3 flex-xl-column text-center align-items-center">
					<h3 className={"h6 text-uppercase font-weight-bolder mb-0" + (R.isNil(addressName) || addressName.trim() === "" ? " my-auto" : " mt-auto")}>{branch.name}</h3>
					{!R.isNil(branch.address.addressLocality) && branch.address.addressLocality.trim() !== "" ? (
						<div className="mw-100 mt-2 mb-auto small align-items-start mw-100 lh-copy">
							<i className="eva eva-home-outline mr-1 h4 lh-1 mb-auto align-middle"></i>
							<span className="o-70">{branch.address.addressLocality == "Invalid" ? "Lien de connexion" : branch.address.addressLocality}</span>
						</div>
					) : (
						""
					)}
				</div>
			</div>
		);
	}

	return (
		<form className={"card rounded border-dim flex-xl-row picker-card active shadow align-self-center grid-column-lg-4"} id={branch.id} ref={inputRef}>
			<div className="card-header py-4 py-xl-3 flex-xl-column text-center align-items-center col-xl-5">
				<h3 className={"h6 text-uppercase font-weight-bolder mw-100" + (R.isNil(addressName) || addressName.trim() === "" ? " my-auto" : " mt-auto")}>
					{connectionType === ConnectionTypes.socialSecurity
						? branch.name.toUpperCase().indexOf("MSA") > -1 || branch.name.toUpperCase().indexOf("CAMIEG") > -1 || branch.name.toUpperCase().indexOf("CNMSS") > -1 || branch.name.toUpperCase().indexOf("ENIM") > -1 || branch.name.toUpperCase().indexOf("CANSSM") > -1 || branch.name.toUpperCase().indexOf("CPRPSNCF") > -1 || branch.name.toUpperCase().indexOf("MGEN") > -1
							? branch.name
							: "CPAM"
						: connectionType === ConnectionTypes.poleEmploi
						? "France Travail"
						: connectionType === ConnectionTypes.taxes
						? "Service des impôts des particuliers"
						: branch.name}
				</h3>
				{addressName.indexOf("Pas d'adresse") > -1 || addressName.indexOf("00000") > -1 ? (
					<div className="mw-100 mt-2 mb-auto small align-items-start mw-100 lh-copy">
						{/*<i className="eva eva-home-outline mr-1 h4 lh-1 mb-auto align-middle"></i>*/}
						<span className="o-70">&nbsp;</span>
					</div>
				) : !R.isNil(addressName) && addressName.trim() !== "" ? (
					<div className="mw-100 mt-2 mb-auto small align-items-start mw-100 lh-copy">
						<i className="eva eva-home-outline mr-1 h4 lh-1 mb-auto align-middle"></i>
						<span className="o-70">{addressName}</span>
					</div>
				) : (
					""
				)}
			</div>

			<div className="card-body pt-0 pb-3 pt-xl-3 flex-xl-column col">
				<div className="form-block mb-2">
					{connectionType === ConnectionTypes.notary
						? ""
						: payloads.items.map((br, index) => {
								return (
									<div className="form-row" key={connectionType + index}>
										<div className="col form-group mb-xs">
											<div className="flex-row gx-2 align-items-center mb-1">
												<label htmlFor={"reference" + index + "-" + boxIndex} className="label h6 lh-root font-weight-bold">
													{fieldName}
												</label>
												<p
													className="form-text small text-gray my-auto ml-auto"
													data-toggle="tooltip"
													data-placement="top"
													data-html="true"
													data-template='<div class="tooltip" role="tooltip"><div class="arrow"></div><div class="tooltip-inner px-3 py-2 fs-2"></div></div>'
													title="Une référence permet à vos organismes de vous identifier afin de faire les démarches nécessaires.">
													<i className="eva eva-info-outline mr-1 fs-sm lh-root align-middle"></i>
												</p>
											</div>
											<div className="input-group mb-0">
												<input
													pattern=".*\S+.*"
													required={true}
													autoFocus={inputOnFocus || (autoFocus && index === payloads.items.length - 1)}
													type="text"
													className="form-control rounded"
													id={"reference" + index + "-" + boxIndex}
													placeholder="xxxxxxxxxxx"
													aria-describedby="basic-addon2"
													value={!R.isNil(br) && !R.isNil(br.payload) ? br.payload.reference : ""}
													disabled={disableModifications && !R.isEmpty(br.id) && !R.startsWith("new", br.id)}
													onChange={(e) => {
														e.preventDefault();
														setPayloads({
															...payloads,
															items: payloads.items.map((i) => {
																if (i.id !== br.id) {
																	return i;
																} else {
																	return { ...br, payload: { ...br.payload, reference: e.target.value } };
																}
															}),
														});
													}}
												/>

												{
													//!displayComments && !R.isEmpty(br.id) ?
													//    ''
													//:
													disableModifications && !R.isEmpty(br.id) && !R.startsWith("new", br.id) ? (
														""
													) : (index === 0 ? br.payload.reference !== "" : true) ? (
														<span
															className="btn btn-sm btn-icon px-xs btn-alert-danger ml-1 border-none rounded"
															id="basic-addon2"
															onClick={(e) => {
																e.preventDefault();
																if (!R.isNil(br.id) && br.id !== "" && !R.startsWith("new", br.id)) {
																	let tmpToDelete = toDelete.concat(br.id);
																	setToDelete(tmpToDelete);
																	dispatch(deleteServiceData(br.id, connectionType));
																}
																let newPayload = payloads.items.filter((i) => i.id !== br.id);
																if (newPayload.length === 0) {
																	newPayload.push({ id: "", payload: new Generic({ reference: "", comment: "" }) });
																}
																setPayloads({ ...payloads, items: newPayload });
															}}>
															<i className="eva eva-trash-2-outline"></i>
														</span>
													) : (
														""
													)
												}
											</div>
										</div>
										{displayComments ? (
											<div className="col-auto form-group mb-xs">
												<div className="flex-row gx-2 align-items-center mb-1">
													<label htmlFor={"referenceComentaire" + index + "-" + boxIndex} className="label h6 lh-root font-weight-bold">
														Commentaire
													</label>
													<p
														className="form-text small text-gray my-auto ml-auto"
														data-toggle="tooltip"
														data-placement="top"
														data-html="true"
														data-template='<div class="tooltip" role="tooltip"><div class="arrow"></div><div class="tooltip-inner px-3 py-2 fs-2"></div></div>'
														title="Les cases commentaires sont personnelles (ne seront pas visibles par le référent), elles vous permettent d'ajouter des notes à vos services.">
														<i className="eva eva-info-outline mr-1 fs-sm lh-root align-middle"></i>
													</p>
												</div>
												<div className="input-group mb-0">
													<input
														type="text"
														className="form-control rounded"
														id={"referenceComentaire" + index + "-" + boxIndex}
														placeholder="xxxxxxxxxxx"
														value={!R.isNil(br) && !R.isNil(br.payload) ? br.payload.comment : ""}
														disabled={disableModifications && !R.isEmpty(br.id) && !R.startsWith("new", br.id)}
														onChange={(e) => {
															e.preventDefault();
															setPayloads({
																...payloads,
																items: payloads.items.map((i) => {
																	if (i.id !== br.id) {
																		return i;
																	} else {
																		return { ...br, payload: { ...br.payload, comment: e.target.value } };
																	}
																}),
															});
														}}
													/>
													{disableModifications && !R.isEmpty(br.id) ? (
														""
													) : (index === 0 ? br.payload.reference !== "" : true) ? (
														<span
															className="btn btn-sm btn-icon px-xs btn-alert-danger ml-1 border-none rounded"
															id="basic-addon2"
															onClick={(e) => {
																e.preventDefault();
																if (!R.isNil(br.id) && br.id !== "") {
																	let tmpToDelete = toDelete.concat(br.id);
																	setToDelete(tmpToDelete);
																	dispatch(deleteServiceData(br.id, connectionType));
																}
																let newPayload = payloads.items.filter((p, idx) => idx !== index);
																if (newPayload.length === 0) {
																	newPayload.push({ id: "", payload: new Generic({ reference: "", comment: "" }) });
																}
																setPayloads({ ...payloads, items: newPayload });
															}}>
															<i className="eva eva-trash-2-outline"></i>
														</span>
													) : (
														""
													)}
												</div>
											</div>
										) : (
											""
										)}
										<div className={"col invalid-feedback alert-danger alert"}>Champs invalide</div>
									</div>
								);
						  })}
					{connectionType === ConnectionTypes.notary ? (
						""
					) : (
						<button
							type="button"
							className="btn btn-icon p-0 align-middle text-gray no-outline mr-auto mb-xs"
							onClick={(e) => {
								e.preventDefault();
								setPayloads({ ...payloads, items: payloads.items.concat({ id: "new" + payloads.items.length, payload: new Generic({ reference: "", comment: "" }) }) });
								setAutoFocus(true);
							}}>
							<i className="eva eva-plus-circle-outline fs-lead align-middle text-secondary mr-1"></i>
							<span className="btn-text aling-middle">Ajouter une autre référence</span>
						</button>
					)}
				</div>

				<div className={"form-footer mb-xl-6 my-xl-auto" + (connectionType === ConnectionTypes.notary ? " align-self-center" : "")}>
					<button
						className={"btn btn-sm btn-alert-info border-none loading-btn" + (isLoading.includes(Loadings.CREATING_USER_SERVICES_DATA + "_" + branch.id) || isLoading.includes(Loadings.UPDATING_USER_SERVICES_DATA + "_" + branch.id) ? " show" : "")}
						disabled={isLoading.includes(Loadings.UPDATING_USER_SERVICES_DATA + "_" + branch.id) || isLoading.includes(Loadings.CREATING_USER_SERVICES_DATA + "_" + branch.id) || payloads.items.every((i) => !i.id.startsWith("new") && i.id !== "")}
						onClick={(e) => {
							e.preventDefault();
							if (connectionType !== ConnectionTypes.notary) {
								inputRef.current.classList.add("was-validated");
								if (inputRef.current.checkValidity()) {
									let payloadsToHandle = payloads.items;
									if (disableModifications) {
										payloadsToHandle = payloads.items.filter((i) => i.id === "" || R.startsWith("new", i.id));
									}
									payloadsToHandle.forEach((payload) => {
										let serviceData = new ServiceData({ userId: userId, serviceType: convertConnectionTypesToServiceType(connectionType), serviceId: branch.id, payload: payload.payload });
										if (R.isNil(payload.id) || payload.id === "" || R.startsWith("new", payload.id)) {
											dispatch(createServiceData(serviceData)).then((s) => {
												if (generateLetters) {
													dispatch(generateLettersForUserIdAndUserServiceId(userId, s.id));
												}
											});
										} else {
											dispatch(updateServiceData({ ...serviceData, id: payload.id }));
										}
									});
									setPayloads({ ...payloads, items: [] });
									setToDelete([]);
									setSearchFilter([]);
								}
							} else {
								//Notaire
								let tmpContracts = JSON.parse(JSON.stringify(contractReference));
								tmpContracts[branch.id] = branch.id;
								setContractReference(tmpContracts);

								const serviceDataIndex = serviceDatas.findIndex((s) => s.serviceId === branch.id);
								const serviceData = new ServiceData({ userId: userId, serviceType: convertConnectionTypesToServiceType(connectionType), serviceId: branch.id, payload: new Generic({ reference: branch.id }) });
								if (serviceDataIndex === -1) {
									dispatch(createServiceData(serviceData)).then((s) => {
										if (generateLetters) {
											dispatch(generateLettersForUserId(userId));
										}
									});
								}
							}
						}}>
						enregistrer
						<div className="loading loading-spinner spinner-border spinner-border-sm ml-2 mr-n1"></div>
					</button>

					{!R.isNil(contractReference[branch.id]) && contractReference[branch.id] !== "" && connectionType === ConnectionTypes.notary ? (
						<span
							className="btn btn-sm btn-icon px-xs btn-alert-danger ml-1 border-none"
							id="basic-addon2"
							onClick={(e) => {
								e.preventDefault();
								//Notary
								let tmpContracts = JSON.parse(JSON.stringify(contractReference));
								tmpContracts[branch.id] = "";
								setContractReference(tmpContracts);

								const serviceDataIndex = serviceDatas.findIndex((s) => s.serviceId === branch.id);
								if (serviceDataIndex !== -1) {
									dispatch(deleteServiceData(serviceDatas[serviceDataIndex].id, connectionType)).then(() => {
										if (generateLetters) {
											dispatch(generateLettersForUserId(userId));
										}
									});
								}
							}}>
							<i className="eva eva-trash-outline"></i>
						</span>
					) : (
						""
					)}
				</div>
			</div>
		</form>
	);
};
